import React from 'react';
import './style.scss';
import { cycleMapping, formatVND } from 'pages/QrCodeMyVnptVer2/constant/contanst';

const PackageItem = ({ data, onClick }) => {
  const listHotKey = data?.listHotKey ? data?.listHotKey?.split(",").slice(0, 3) : [];

  return (
    <div className="package-item" onClick={onClick}>
      <div className="package-item-img">
        <img src={data?.imageUrl} alt="" />
      </div>
      <div className="package-item-body">
        <div className="package-item-content">
          {
            listHotKey && (
              <div className="package-item-tag">
                {
                  listHotKey.map((e, index) => (
                    <div key={index}>{e}</div>
                  ))
                }
              </div>
            )
          }
          <div className="package-item-name">{data?.packageName}</div>
          <div className="package-item-des" dangerouslySetInnerHTML={{ __html: data?.description }} />
        </div>
        <div className="package-item-price">{formatVND(data?.price)}/ {data?.cycleDesc}</div>
      </div>
    </div>
  )
};

export default React.memo(PackageItem);
